import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=2a0324db&scoped=true&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=ts&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=2a0324db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0324db",
  null
  
)

export default component.exports